export default function Content() {
  return (
    <footer className="container">
      <div className="container">
        <div className="content row">
          <h2 className="title">World wild fires in real time</h2>
          <p>
            Discover what are some of the forestry events that are happening
            anywhere in the world right now. Find the 🔥 that are you looking
            for and <b>Click On it</b> to get more detail about the event.
          </p>
        </div>
      </div>
    </footer>
  );
}
